<template>
    <div style="width: 800px; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px;">
        <p>
            Матрица Эйзенхауэра является инструментом, позволяющим рационально распоряжаться собственным временем. Она исходит из предпосылки, что время является ограниченным и ценным ресурсом. Посмотрите, как матрица предлагает разделить необходимые для выполнения дела на группы.
        </p>

        <table border="1" cellspacing="0" cellpadding="0" width="100%" style="font-size: 16px;">
            <tbody>
            <tr>
                <th width="30"></th>
                <th style="padding: 10px;" align="center" width="50%"><i>Срочно</i></th>
                <th style="padding: 10px;" align="center" width="50%"><i>Не срочно</i></th>
            </tr>
            <tr>
                <td align="center" valign="middle" style="padding: 5px;">
                    В
                    А
                    Ж
                    Н
                    О
                </td>
                <td style="padding: 15px;" valign="top">
                    Эта часть дел минимальна. Их список пополняется только незапланирован-ными, внезапно возникшими делами.
                    <br>
                    <br>
                    <strong>Например:</strong>
                    <ul style="margin-left: 20px;">
                        <li>дела, невыполнение которых отрицательно сказывается на достижении поставленных целей,</li>
                        <li>дела, невыполнение которых может стать причиной затруднений и неприятностей,</li>
                        <li>дела, которые имеют отношение к здоровью.</li>
                    </ul>
                </td>
                <td style="padding: 15px;" valign="top">
                    Наиболее приоритетные, перспективные и результативные дела, которые ведут к важной цели. Отсутствие спешки помогает наметить сроки и способы выполнения задачи. Эти дела чаще всего приводят к успеху.
                    <br>
                    <br>
                    <strong>Например:</strong>
                    <ul style="margin-left: 20px;">
                        <li>текущие запланированные дела, связанные с основной деятельностью,</li>
                        <li>планирование, подготовка и анализ работы,</li>
                        <li>учебные и спортивные занятия,</li>
                        <li>соблюдение графика дел и режима питания,</li>
                        <li>налаживание отношений – семья, друзья, родные,</li>
                        <li>самосовершенствование – чтение литературы, посещение тренингов.</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td align="center" valign="middle" style="padding: 5px;">
                    Н
                    Е
                    В
                    А
                    Ж
                    Н
                    О
                </td>
                <td  style="padding: 15px;" valign="top">
                    Это незапланированные второстепен-ные дела, никак не влияющие на нашу жизнь, но требующие срочного внимания.
                    <br>
                    <br>
                    <strong>Например:</strong>
                    <ul style="margin-left: 20px;">
                        <li>навязанные кем-либо со стороны встречи или переговоры, от которых нельзя отказаться,</li>
                        <li>празднование дней рождения не очень близких людей,</li>
                        <li>внезапно возникшие хлопоты по дому,</li>
                        <li>устранение не жизненно важных, но требующих внимания отвлекающих факторов (разбилась ваза, внезапный телефонный звонок и т.п.).</li>
                    </ul>
                </td>
                <td  style="padding: 15px;" valign="top">
                    Дела, которые не приносят совсем никакой пользы, именно они являются поглотителями времени. Они также являются очень привлекательными для многих людей – эти дела просты в выполнении и доставляют удовольствие. Часто советуют то, что от них просто нужно избавляться.
                    <br>
                    <br>
                    <strong>Например:</strong>
                    <ul style="margin-left: 20px;">
                        <li>разговоры «ни о чем» по телефону или в соцсетях.</li>
                        <li>бесцельный просмотр телепередач или сериалов.</li>
                        <li>компьютерные не развивающие игры.</li>
                        <li>Более интересные и развивающие способы развлечений: чтение хороших книг, интеллектуальные игры, посещение спортзалов и бассейнов, поездки на природу и т.п.</li>
                    </ul>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    export default {}
</script>
<style scoped></style>